import { render, staticRenderFns } from "./CurationListSendLayout.vue?vue&type=template&id=168b10a6&scoped=true"
import script from "./CurationListSendLayout.vue?vue&type=script&lang=js"
export * from "./CurationListSendLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168b10a6",
  null
  
)

export default component.exports